import { Link } from "gatsby";
import * as React from "react";
import {
  container,
  destinationContainer,
  subTitle,
  title,
  description,
  cityContainer,
  findYourDestination,
} from "./FeaturedDestinations.module.scss";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const DestinationContainer: React.FC<any> = (props) => {
  return <div className={destinationContainer}>{props.children}</div>;
};
export const CityContainer: React.FC<any> = (props) => {
  return <div className={cityContainer}>{props.children}</div>;
};
export const StyledSubTitle: React.FC<any> = (props) => {
  return <div className={subTitle}>{props.children}</div>;
};
export const Title: React.FC<any> = (props) => {
  return <div className={title}>{props.children}</div>;
};
export const Description: React.FC<any> = (props) => {
  return (
    <div
      className={description}
      dangerouslySetInnerHTML={{ __html: props.field_description }}
    ></div>
  );
};
export const FindYourDestination: React.FC = () => {
  return (
    <div className={findYourDestination}>
      <Link
        to="/locations"
        className="find-link font-weight-black text-center text-sm-left"
      >
        Find Your Destination
      </Link>
    </div>
  );
};
